// Small formatting helpers for User Management.

const MINUTE = 60 * 1000;
export const DAY = 24 * 60 * MINUTE;

export const day = (iso) => (iso ? new Date(iso).toLocaleDateString('en-US', {
  month: 'short', day: 'numeric', ...(new Date(iso).getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}),
}) : '');

// "just now", "25 min ago", "3 h ago", "yesterday", "4 days ago", "on Oct 2"
export const ago = (iso) => {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 10 * MINUTE) return 'just now';
  if (diff < 60 * MINUTE) return `${Math.round(diff / MINUTE)} min ago`;
  if (diff < DAY) return `${Math.round(diff / (60 * MINUTE))} h ago`;
  if (diff < 2 * DAY) return 'yesterday';
  if (diff < 14 * DAY) return `${Math.floor(diff / DAY)} days ago`;
  return `on ${day(iso)}`;
};

export const isStale = (iso) => Boolean(iso) && Date.now() - new Date(iso).getTime() > 30 * DAY;

export const displayName = (u) => [u.first_name, u.last_name].filter(Boolean).join(' ').trim() || u.username;

export const initialsOf = (name) => (name || '').split(/\s+/).filter(Boolean).map((part) => part[0]).join('').slice(0, 2).toUpperCase();
